<template>
    <loading name="load image list">
        <div class="container mt-3">
            <div class="row p-4">
                <div class="col-6 align-text-bottom">
                    <h3>{{ $t('pages.ListImages') }}</h3>
                </div>
                <div class="col-6 text-right mb-3">
                    <router-link class="btn btn-primary" to="/images/create"><i class="fas fa-plus mr-2"></i>{{ $t('button.CreateImage') }}</router-link>
                </div>
                <hr>
                <div class="col-12">
                    <table class="table table-borderless table-striped">
                        <thead>
                        <tr>
                            <th scope="col">{{ $t('fields.Image') }}</th>
                            <th scope="col">{{ $t('fields.Title') }}</th>
                            <th scope="col">{{ $t('fields.Text') }}</th>
                            <th scope="col">{{ $t('fields.Order') }}</th>
                            <th scope="col">{{ $t('fields.Actions') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="image in sliderImages" :key="'image-' + image.id">
                            <td><img v-lazy="image.image"></td>
                            <td>{{image.title}}</td>
                            <td v-html="image.text"></td>
                            <td>{{image.order}}</td>
                            <td>
                                <router-link :to="'/images/' + image.id" class="mr-3">{{ $t('button.Edit') }}</router-link>
                                <a @click="(e) => deleteItem(e, image.id)" href="#">{{ $t('button.Delete') }}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'SliderImages',
    computed: {
      ...mapGetters(['sliderImages'])
    },
    mounted() {
      this.$wait.start('load image list');
      return this.loadSliderImages()
        .then(() => this.$wait.end('load image list'));
    },
    methods: {
      ...mapActions(['loadSliderImages', 'deleteImage']),
      deleteItem(e, id) {
        e.preventDefault();
        this.deleteImage({id})
      }
    }
  };
</script>

<style scoped>

</style>
